import { CURLY_APOSTROPHES, EMAIL_REGEX } from '@/constants/validators';

export const normalizeEmail = (value: string): string =>
  value.trim().replace(CURLY_APOSTROPHES, "'");

export const isValidEmail = (value: string): boolean => EMAIL_REGEX.test(normalizeEmail(value));
